export default __webpack_public_path__ + "static/media/logo1.e572d607.png";